"use strict";
exports.__esModule = true;
var initialState = function () { return ({
    data: null,
    error: null,
    loading: true
}); };
exports["default"] = initialState;
